/* eslint-disable no-unused-labels */
import moment from "moment"
import { consts } from "@/store/constants"
import { utils } from "@/store/helpers"

class Formulary {
  raw_formulary = null
  constructor(data) {
    this.raw_formulary = utils.clone(data)

    // unpack formulary for frontend usage
    this.formulary = []
    for (const [key, value] of Object.entries(this.raw_formulary)) {
      switch (key) {
        case consts.FORMULA_TYPES.CASES:
          var unpackd_cases = []
          value.cases.forEach((case_exp) => {
            unpackd_cases.push(Formulary.parseServerCaseExpression(case_exp))
          })
          this.formulary.push({
            type: consts.FORMULA_TYPES.CASES,
            cases: unpackd_cases,
            default: Formulary.parseServerExpression(value?.default)
          })
          break
        case consts.FORMULA_TYPES.VALUE:
          this.formulary.push({ type: consts.FORMULA_TYPES.VALUE, expression: Formulary.parseServerExpression(value?.expression) })
          break
        case consts.FORMULA_TYPES.FILTER:
          this.formulary.push({ type: consts.FORMULA_TYPES.FILTER, expression: Formulary.parseServerExpression(value?.expression) })
          break
        default:
          console.warn(`${key} is not valid formula type`)
      }
    }
  }
  isValid() {
    let errors = []
    for (const [key, value] of Object.entries(this.formulary)) {
      switch (key) {
        case consts.FORMULA_TYPES.CASES:
          value.cases.forEach((case_exp) => {
            if (Formulary.isCaseExpressionInValid(case_exp)) {
              errors.push(case_exp)
            }
          })
          if (utils.isNotEmpty(value?.default)) {
            if (Formulary.isExpressionInValid(value.default)) {
              errors.push(value.default)
            }
          }
          break
        case consts.FORMULA_TYPES.VALUE:
          if (Formulary.isExpressionInValid(value.expression)) {
            errors.push(value.expression)
          }
          break
        case consts.FORMULA_TYPES.FILTER:
          if (Formulary.isExpressionInValid(value.expression)) {
            errors.push(value.expression)
          }
          break
        default:
          console.warn(`${key} is not valid formula type`)
      }
    }
    return errors.length == 0
  }
  static isCaseExpressionInValid(case_exp) {
    return Formulary.isExpressionInValid(case_exp.when) || Formulary.isExpressionInValid(case_exp.then)
  }
  static isExpressionInValid(exp) {
    if (utils.isEmpty(exp)) {
      return false
    }
    let errors = []
    exp.forEach((el) => {
      // metric,func,operator
      if (el.type == "value" && utils.isEmpty(el.value)) {
        errors.push(el)
      }
    })
    return errors.length == 0
  }

  // Parse
  static parseServerExpression(exp) {
    if (utils.isEmpty(exp)) {
      return []
    }

    let unpackd_exp = []
    exp.forEach((el, index) => {
      // metric,func,operator
      if (consts.FORMULARY_OPTIONS_NO_NUMBERS[el]) {
        unpackd_exp.push(consts.FORMULARY_OPTIONS_NO_NUMBERS[el])
      } else {
        let operand_type = unpackd_exp[index + 2]?.type || unpackd_exp[index - 2]?.type
        // let operator = unpackd_elements[index+1]?.type || unpackd_elements[index-1]?.type
        unpackd_exp.push({ type: "value", value: el, data_type: operand_type })
      }
    })
    return unpackd_exp
  }
  static parseServerCaseExpression(case_exp) {
    return {
      type: consts.FORMULA_TYPES.CASE,
      when: Formulary.parseServerExpression(case_exp.when),
      then: Formulary.parseServerExpression(case_exp.then)
    }
  }

  // parse Formula To be send to server POST
  static packExpression(exp) {
    let packd_exp = []
    exp.forEach((el, index) => {
      // metric,func,operator
      if (consts.FORMULARY_OPTIONS_NO_NUMBERS[el?.value]) {
        packd_exp.push(el.value)
      } else {
        // let operator = packd_elements[index+1]?.type || packd_elements[index-1]?.type
        let operand_type = packd_exp[index + 2]?.type || packd_exp[index - 2]?.type

        if ([consts.DATA_TYPES.DateTime, consts.DATA_TYPES.Date].includes(operand_type)) {
          packd_exp.push(moment(el.value).toISOString())
        } else {
          packd_exp.push(el.value)
        }
      }
    })
    return packd_exp
  }
  static packCaseExpression(case_exp) {
    return { type: consts.FORMULA_TYPES.CASE, when: Formulary.packExpression(case_exp.when), then: Formulary.packExpression(case_exp.then) }
  }

  // get FE formulary
  get formulary() {
    return this._formulary
  }

  set formulary(val) {
    this._formulary = val
    this._formularyChanged()
  }

  _formularyChanged() {
    let raw_formulary = []
    this._formulary.forEach((value) => {
      switch (value.type) {
        case consts.FORMULA_TYPES.CASES:
          var unpackd_cases = []
          value.cases.forEach((case_exp) => {
            unpackd_cases.push(this.packCaseExpression(case_exp))
          })
          this.raw_formulary.push({ cases: unpackd_cases, default: this.packExpression(value.default) })
          break
        case consts.FORMULA_TYPES.CASE:
          this.raw_formulary.push({
            type: consts.FORMULA_TYPES.CASE,
            when: this.packExpression(value.when),
            then: this.packExpression(value.then)
          })
          break

        case consts.FORMULA_TYPES.VALUE:
          this.raw_formulary.push({ type: consts.FORMULA_TYPES.VALUE, expression: this.packExpression(value) })
          break
        case consts.FORMULA_TYPES.FILTER:
          this.raw_formulary.push({ type: consts.FORMULA_TYPES.FILTER, expression: this.packExpression(value) })
          break
        default:
          console.warn(`${value.type} is not valid formula type`)
      }
    })

    this.raw_formulary = raw_formulary
  }
}

class Metric {
  constructor(data) {
    order: Number
    reference_name: String
    name: String
    description: String
    data_sources: Array
    included_metrics: Array
    metric_class: String
    object_type: String
    is_public: Boolean
    aggregation_method: String
    data_type: String
    input_type: String
    input_options: Object
    metric_colors: Object
    is_primary_metric_color: Boolean
    is_score_logic_reversed: Boolean
    is_rs_metric: Boolean
    parent_object_type: String
    is_name_changeable: Boolean
    created_by: Date
    last_updated_by: Date

    this.raw_data = data
    this.raw_formulary = utils.clone(data.formulary)

    // unpack formulary for frontend usage
    this.formulary = new Formulary(this.raw_formulary).formulary

    // we set the normal fields
    for (const [key, value] of Object.entries(data).filter((k) => k != "formulary")) {
      Object.defineProperty(this, key, {
        value: value,
        writable: true
      })
    }
  }
}

export { Metric, Formulary }
